/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_From_NotesInputs */



/**
* | output |
* | --- |
* | "from the notes" |
*
* @param {Meeting_Topics_From_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_from_notes = /** @type {((inputs?: Meeting_Topics_From_NotesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_From_NotesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("uit de notities")
	if (locale === "fr") return /** @type {LocalizedString} */ ("à partir des notes")
	return /** @type {LocalizedString} */ ("from the notes")
});